import { 
	GET_ADDRESS_BOOK_COMPANY_CONTACTS, 
	GET_ADDRESS_BOOK_COMPANY_CONTACT,
	CREATE_ADDRESS_BOOK_COMPANY_CONTACT,
	UPDATE_ADDRESS_BOOK_COMPANY_CONTACT,
	DESTROY_ADDRESS_BOOK_COMPANY_CONTACT,
	FIND_OR_CREATE_ADDRESS_BOOK_COMPANY_CONTACT,
} from "./actions"

export function AddressBookCompanyContactsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_ADDRESS_BOOK_COMPANY_CONTACTS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_ADDRESS_BOOK_COMPANY_CONTACT}_FULFILLED`:
		case `${CREATE_ADDRESS_BOOK_COMPANY_CONTACT}_FULFILLED`:
		case `${FIND_OR_CREATE_ADDRESS_BOOK_COMPANY_CONTACT}_FULFILLED`:
		case `${UPDATE_ADDRESS_BOOK_COMPANY_CONTACT}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_ADDRESS_BOOK_COMPANY_CONTACT}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { AddressBookCompanyContactsReducer } from "modules/address_book/company/contacts/reducer"

// address_book_company_contacts:AddressBookCompanyContactsReducer,
